import * as React from "react";
import { Provider } from "@fluentui/react-northstar/dist/es/components/Provider/Provider";
import { useState, useEffect } from "react";
import { useTeams } from "msteams-react-base-component";
import * as microsoftTeams from "@microsoft/teams-js";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
// import CpbxLogin from "../../components/CpbxLogin/CpbxLogin";
import CpbxPhoneSettings from "../../components/CpbxPhoneSettings/CpbxPhoneSettings";
// import { ICpbxLoginProps } from "../../components/CpbxLogin/ICpbxLoginProps";
import DataPrivacyLastUpdated from "../../components/DataPrivacyLastUpdated/DataPrivacyLastUpdated";
import { CpbxThemeSelector } from "../../components/CpbxThemeSelector/CpbxThemeSelector";
import VerhinderungAppNutzungDialog from "../../components/VerhinderungAppNutzung/VerhinderungAppNutzungDialog";
import Verhinderung from "../../components/Verhinderung/Verhinderung";

/**
 * Implementation of the TabCpbxSettings content page
 */
export const TabCpbxSettings = () => {

    const [{ inTeams, theme, context }] = useTeams();
    const [entityId, setEntityId] = useState<string>();

    // we need azure user object-id for each request to xsi or ums (as part of decryption-stuff)
    const [msTeamsUid, setUserObjectId] = useState<string>();

    // check if login has been done already
    const isCpbxLoggedIn: boolean = LocalCacheHelper.DoesLocalCacheKeysForCbpxLoginExists();

    useEffect(() => {
        if (inTeams === true) {
            microsoftTeams.appInitialization.notifySuccess();
        }
        if (inTeams === false) {
            const outContext = { theme: "default" };
            CpbxThemeSelector(outContext);
        } else {
            setEntityId("Not in Microsoft Teams");
        }
    }, [inTeams]);

    useEffect(() => {
        microsoftTeams.registerOnThemeChangeHandler(function(theme) {
            CpbxThemeSelector(theme);
            console.log(theme);
        });
        if (context) {
            setEntityId(context.entityId);
            setUserObjectId(context.userObjectId);
            CpbxThemeSelector(context);
        }
    }, [context]);

    // if (isCpbxLoggedIn) {
    /* const cpbxUsername: string = LocalCacheHelper.GetLocalStorageItemCbpxUserNameAsString();
        const cpbxImpId: string = LocalCacheHelper.GetLocalStorageItemCbpxUserImpIdFromProfileMe();
        const contextProps : ICpbxLoginInfoProps = {
            M365Upn: msTeamsUpn,
            CpbxUser: cpbxUsername,
            CpbxImpId: cpbxImpId
        };
        // check if ms-teams context is available
        if (context) {
            // context is available so do not show headline
            return (
                <Provider theme={theme} className="CpbxProviderContainer">
                    <CpbxLoginInfo {...contextProps} />
                    <CpbxPhoneSettings />
                </Provider>
            );
        } else {
            // context is NOT available so do show some additional information for web-view (without ms-teams)

            const items: IBreadcrumbItem[] = [
                { text: "Home", key: "home", href: "/" },
                { text: "Phone-Settings", key: "phonesettings", isCurrentItem: true }
            ];

            return (
                <Provider theme={theme} className="CpbxProviderContainer">
                    <Breadcrumb items={items} />
                    <CpbxLoginInfo {...contextProps} />
                    <CpbxPhoneSettings />
                </Provider>
            );
        } */

    return (
        <Provider theme={theme} className="cpbxProviderContainer">
            {/* <DataPrivacyLastUpdated />  */}
            <Verhinderung />
        </Provider>
    );

    // } else {
    // azure user object-id is just needed as dynamically retrieved data while login
    // if login succeeded this value will be stored to local-storage / session-storage
    // const localDevTestUserId = "11111111-1111-1111-1111-111111111111";
    // const cpbxLoginProps: ICpbxLoginProps = { M365UserObjectId: (msTeamsUid ?? localDevTestUserId) };
    // }
};
